import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { pick, prop } from 'ramda';
import { useGetGeoIP } from 'server';
import { useAppSelector, useSocketSelector, useUserSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useGeoIP = () => {
    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const getGeoIP = useGetGeoIP();
    const casinoName = useAppSelector(prop('casinoName'));
    const countrySetByGeoIp = useUserSelector(prop('countrySetByGeoIp'));
    const { connected, isError } = useSocketSelector(pick(['connected', 'isError']));

    useEffect(() => {
        if (countrySetByGeoIp || isLoading) {
            return;
        }

        if (isError) {
            dispatch(actions.setCountryByGeoIP('XX'));

            return;
        }

        if (!casinoName || !connected) {
            return;
        }

        (async () => {
            try {
                setLoading(true);

                const {
                    country = 'XX',
                    resolvedProperties = []
                } = await getGeoIP();

                dispatch(actions.setCountryByGeoIP(country));

                const {
                    accuracyRadius = '',
                    city = '',
                    latitude = '',
                    longitude = '',
                    state = ''
                } = resolvedProperties.reduce((map, { key, value }) => {
                    map[key] = value;
                    return map;
                }, {});

                dispatch(actions.setGeoData({
                    accuracyRadius,
                    city,
                    latitude,
                    longitude,
                    state
                }));
            } catch {
                dispatch(actions.setCountryByGeoIP('XX'));
            } finally {
                setLoading(false);
            }
        })();
    }, [
        casinoName,
        connected,
        countrySetByGeoIp,
        dispatch,
        getGeoIP,
        isError,
        isLoading
    ]);
};
